import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Link } from 'react-router';
import _ from 'lodash';
import moment from 'moment';

/* Dialogs */
import EmailSpecOverlayDialog from '../../dialogs/emailSpecOverlayDialog';
import EmailSpecOverlayDialogSuccess from '../../dialogs/emailSpecOverlayDialogSuccess';
import AvailabilityByADCOverlayDialog from '../../dialogs/availabilityByADCOverlayDialog';

import AddToCart from '../common/AddToCart';
import AddToList from '../common/AddToList';

import { processPricingResponse } from '../../../redux/util';
import ToolTipOverlayDialog from '../../dialogs/toolTipOverlayDialog';

/* Actions */
import {
	resetProductAvailabilityResultList,
	saveProductResultAvailability,
	// closeoutModelAvailability,
	updateAvailabilityWithPricesAndDiscounts,
	getADC,
	saveADC,
	getPIMItemInfo,
	checkPricesForSearchResult,
	saveProductResultPrices,
	getSearchKeywordSuggestionList,
} from '../../../redux/actions';

import { routes } from '../../../redux/api/routes';

let { productGEUrl } = routes;

class PostLoginSearchResult extends Component {

    constructor(props){
        super(props);
        this.state = {
            showEmailSpecOverlayDialog: false,
            specURL: '',
			showPhotos: true,
			showDetails: false,
			customerType: 'contract',
			sorting: 'sku',
			showAvailabilityByADCDialog: false,
			availabilityADCData: null,
			showToolTipOverlayDialog: false,
			isPriceDiscountAccess: false,
			priceBreakdownItem: null,
			isPricingAccess: false,
        }
    }

	handleShowHideDetails(flag, event) {
		event.preventDefault();
		this.setState({
			showPhotos: !flag,
			showDetails: flag
		})
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		// TO DO: Check pricing access here from
	}

	componentWillMount() {
		const self = this,
			{ state } = self.props,
			{ userDetails, selectedAccount, localUserDetails } = state.user;
		// self.props.state.product.fromWhere !== 'header' && self.startFetchingData(self.props.params.searchKeyword, self.props.params.typeOfSearch);
		let isPricingAccess = false,
			isPriceDiscountAccess = false;

		if(userDetails.typeOfUser !== "employee") {
			var selectedAccountDetails = localUserDetails && localUserDetails.responseObject && _.find(localUserDetails.responseObject.accounts, ["accountNumber", selectedAccount.ACCOUNTNUMBER]);
			if(selectedAccountDetails && selectedAccountDetails.responsibilities) {
				isPricingAccess = selectedAccountDetails.responsibilities.indexOf("Price") !== -1?true:false;
				isPriceDiscountAccess = selectedAccountDetails.responsibilities.indexOf("Price Discounts") !== -1?true:false;
			}
			if(userDetails.punchOutAccess){
				isPricingAccess = userDetails.punchOutAccess;
				isPriceDiscountAccess = userDetails.punchOutAccess;
			}
		} else if(userDetails.typeOfUser === "employee") {
			isPricingAccess = self.props.isResponsibilityExists("Price");
			isPriceDiscountAccess = self.props.isResponsibilityExists("Price Discounts");
		}
		self.setState({
			isPricingAccess: isPricingAccess,
			isPriceDiscountAccess: isPriceDiscountAccess
		});
	}

	handleSorting(event) {
		var sorting = event.target.value;
		this.setState({
			sorting: sorting
		});
	}

	componentWillReceiveProps(){
		this.setState({
			customerType: this.props.customerType.toLowerCase()
		})
	}

    handleClickEmailSpec(specURL, event) {
        event.preventDefault();
        this.setState({
            specURL: specURL,
            showEmailSpecOverlayDialog: true
        });
    }

	handleClickOnImage(imagePath,event){
        window.location.assign(imagePath);
    }

    formatNumber2Decimal(number) {
		number = (number)?number.trim().replace(/,/g,""):number;
        if(number) {
			number = number.replace("$","");
			number = "$"+parseFloat(number).toFixed(2);
            return number === "$0.00"?"--":number;
        } else {
            return "--";
        }
    }

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handlePriceBreakdownOpen(item, event) {
		event && event.preventDefault();
		this.setState({
			showPriceBreakdownDialog: true,
			priceBreakdownItem: item
		});
	}

	handlePriceBreakdownClose(event) {
		event && event.preventDefault();
		this.setState({
			showPriceBreakdownDialog: false,
			priceBreakdownItem: null
		});
	}

	renderPriceBreakdownModal() {
		const { showPriceBreakdownDialog, priceBreakdownItem } = this.state;
		if (!showPriceBreakdownDialog || !priceBreakdownItem) return null;

		const item = priceBreakdownItem;

		const discountFields = [
			{ label: 'PTS',      field: 'pts' },
			{ label: 'Group PA', field: 'groupPA' },
			{ label: 'Draft',    field: 'draft' },
			{ label: 'VR',       field: 'pvr' },
			{ label: 'SPPA',     field: 'sppa' },
			{ label: 'Promo',    field: 'promo' },
			{ label: 'Other discounts',    field: 'otherDiscounts' },
		];

		let discountRows = [];
		if (item.priceDiscounts && item.priceDiscounts.length > 0) {
			discountRows = item.priceDiscounts.map((d, i) => ({
				label: d.label || `Discount ${i + 1}`,
				amount: d.amount,
				expirationDate: d.expirationDate || null
			}));
		} else {
			discountRows = discountFields
				.filter(d => item[d.field] && item[d.field] !== '' && item[d.field] !== '--')
				.map(d => ({
					label: d.label,
					amount: item[d.field],
					expirationDate: d.field === 'promo' ? item.promoDisplay : null,
					expirationTooltip: d.field === 'promo' ? item.promoExpiration : null
				}));
		}

		const totalDiscounts = discountRows.reduce((sum, d) => {
			const val = parseFloat((d.amount || '').toString().replace(/[$,]/g, ''));
			return sum + (isNaN(val) ? 0 : val);
		}, 0);

		return (
			<div className="priceBreakdownOverlay" style={overlayStyles.backdrop}>
				<div className="priceBreakdownDialog" style={overlayStyles.dialog}>
					<div style={overlayStyles.header}>
						<span style={overlayStyles.title}>PRICE BREAKDOWN</span>
						<button onClick={this.handlePriceBreakdownClose.bind(this)} style={overlayStyles.closeBtn}>✕</button>
					</div>
					<table style={overlayStyles.table}>
						<tbody>
							<tr>
								<td style={overlayStyles.labelCell}>MSRP</td>
								<td style={overlayStyles.valueCell}>{this.formatNumber2Decimal(item.msrp)}</td>
							</tr>
							{this.state.isPricingAccess && item.price &&
								<tr>
									<td style={overlayStyles.labelCell}>Price</td>
									<td style={overlayStyles.valueCell}>{this.formatNumber2Decimal(item.price.toString())}</td>
								</tr>
							}
							{discountRows.map((d, i) => (
								<tr key={i}>
									<td style={overlayStyles.labelCell}>
										{d.label}
										{d.expirationDate ? (
											<span
												style={overlayStyles.expiry}
												title={d.expirationTooltip ? `Promotional price ${d.expirationTooltip}` : undefined}
											>
												{d.label === 'Promo' ? `, ${d.expirationDate}` : `, ${d.expirationDate}`}
											</span>
										) : null}
									</td>
									<td style={{...overlayStyles.valueCell, ...overlayStyles.discountValue}}>
										-{this.formatNumber2Decimal(d.amount != null ? d.amount.toString() : '')}
									</td>
								</tr>
							))}
							{discountRows.length > 0 &&
								<tr style={overlayStyles.totalRow}>
									<td style={overlayStyles.labelCell}>Total discounts</td>
									<td style={{...overlayStyles.valueCell, ...overlayStyles.discountValue}}>
										-${totalDiscounts.toFixed(2)}
									</td>
								</tr>
							}
							<tr style={overlayStyles.netPriceRow}>
								<td style={{...overlayStyles.labelCell, ...overlayStyles.netPriceLabel}}>Net Price</td>
								<td style={{...overlayStyles.valueCell, ...overlayStyles.netPriceValue}}>
									{this.formatNumber2Decimal(item.netPrice != null ? item.netPrice.toString() : '')}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		);
	}

	handleCompareCheck(sku, event) {
		let { state } = this.props;
		let { productResultAvailability } = state.product;
		// if(this.props.typeOfSearch === 'product-number') {
		// 	productResultAvailability = productNumberKeywordResult;
		// }
		var selectedForCompare = _.filter(productResultAvailability, ['forItemToBeCompared', true]).length;
		//Need to add if replacementlist items are selected
		productResultAvailability.map((item, index) => {
			if(item.replacementList && item.replacementList !== "" && item.replacementList.length > 0) {
				item.replacementList.map((itm, ind) => {
					if(itm.forItemToBeCompared === true) {
						selectedForCompare += 1;
					}
					return null;
				});
			}
			return null;
		});
		selectedForCompare = event.target.checked?selectedForCompare+1:selectedForCompare-1;
		if(selectedForCompare > 4) {
			event.preventDefault();
			alert("You can only compare between 2 and 4 products.");
		} else {
			productResultAvailability.map((item, index) => {
				if(item.sku === sku) {
					item.forItemToBeCompared = event.target.checked;
				}
				if(item.replacementList && item.replacementList !== "" && item.replacementList.length > 0) {
					item.replacementList.map((itm, ind) => {
						if(itm.sku === sku) {
							itm.forItemToBeCompared = event.target.checked;
						}
						return null;
					});
				}
				return null;
			});
			//Reset List first then new values will be added
			this.props.resetProductAvailabilityResultList();
			this.props.saveProductResultAvailability({responseObject: productResultAvailability});
			// this.props.updateAvailabilityWithPricesAndDiscounts();
		}
	}

	handleCompareProducts(event) {
		event.preventDefault();
		let { state } = this.props;
		let { productResultAvailability } = state.product;
		// if(this.props.typeOfSearch === 'product-number') {
		// 	productResultAvailability = productNumberKeywordResult;
		// }
		var selectedForCompare = _.filter(productResultAvailability, ['forItemToBeCompared', true]);
		//Need to add if replacementlist items are selected
		productResultAvailability.map((item, index) => {
			if(item.replacementList && item.replacementList !== "" && item.replacementList.length > 0) {
				item.replacementList.map((itm, ind) => {
					if(itm.forItemToBeCompared === true) {
						selectedForCompare.push(itm);
					}
					return null;
				});
			}
			return null;
		});
		if(selectedForCompare.length < 2 || selectedForCompare.length > 4) {
			alert("You can only compare between 2 and 4 products.");
		} else {
			var skus = [];
			skus = selectedForCompare.map((item, index) => {
				return item.sku;
			});
			browserHistory.push('/compare-products/'+this.props.typeOfSearch+'/'+this.props.searchKeyword+'/'+skus.join('+'));
		}
	}

	handleAvailabilityClick(model, closeoutInd, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			showAvailabilityByADCDialog: false
		}, () => {
			const { adcData } = self.props.state.product;
			const findData = _.find(adcData, ['zip', self.props.getZipCode()]);
			if(findData) {
				self.setState({
					showAvailabilityByADCDialog: true,
					availabilityADCData: findData.data
				});
			} else {
				const data = JSON.parse(self.props.state.user.selectedAddress);
				const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
				zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
					if(resp && resp.agentid) {
						let demandClassQP = self.props.getSalesAgreementParamForAvailability();
						demandClassQP =  demandClassQP && demandClassQP.length > 0 ? demandClassQP.substring(1) : "";
						self.props.checkAvailabilityGeneric([{ sku: model,  demandClass: demandClassQP.split("=")[1]}],'', '', true, response => {

							// self.props.saveADC({
							// 	zip: self.props.getZipCode(),
							// 	data: resp
							// });
							self.setState({
								showAvailabilityByADCDialog: true,
								availabilityADCData: {
									...response,
									warehouseCode: resp.agentid
								}
							});
						});
					}
				});
			}
		});
	}

	handleADCDialogStatus(flag) {
		this.setState({
			showAvailabilityByADCDialog: flag
		});
	}

	getIndexes(array, pickFromArray, value) {
		const indexes = [];
		array.forEach((itm, ind) => {
			if (itm === value)
			indexes.push(pickFromArray[ind]);
		});
		return indexes;
	}

	handleReplacement(index, sku, callback, event) {
		event && event.preventDefault();
		const self = this;
		// make service call to get pim details
		self.setState({
			pricingData: index !== null ? self.state.pricingData : [],
			selectedIndex: index !== null ? index : self.state.selectedIndex,
			replacementSKUsSequence: index !== null ? [] : self.state.replacementSKUsSequence,
			pimData: index !== null ? [] : self.state.pimData
		}, () => {
			self.getPimItemsInfo(index, sku, (hasReplacement, replacementSKUs, pimDataResp) => {
				if (!hasReplacement) {
					if(index !== null) {
						self.showNoReplacementAvailableMessage(index, sku);
					} else {
						self.setState({
							pimData: self.state.pimData.concat(pimDataResp)
						}, () => {
							callback && callback();
						});
					}
				} else if(replacementSKUs) {
					self.setState({
						replacementSKUsSequence: self.state.replacementSKUsSequence.concat(replacementSKUs),
						pimData: self.state.pimData.concat(pimDataResp)
					}, () => {
						self.handleReplacement(null, replacementSKUs, () => {
							self.setState({
								isAvailabilityCallCompleted: false,
								isPricingCallCompleted: false,
								isGetItemsCallCompleted: false,
								availabilityData: null,
							}, () => {
								// Make getItems service call for quickSpecPdfName, description, msrp
								self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${self.state.replacementSKUsSequence.join(' ')}&count=${5}&accountNumber=${self.props.accountNumber}&zipCode=${self.props.getZipCode()}&action=viewReplacements`, response => {
									self.setState({
										isGetItemsCallCompleted: true,
										getItemsData: response && response.responseObject
									}, () => {
										self.callBackAfterAvailabilityAndPricing();
									});
								});

								const skuList = [],
									skuListForPricing = [];
								self.state.replacementSKUsSequence.forEach(item => {
									skuList.push({sku: item});
									skuListForPricing.push(item);
								});

								const data = JSON.parse(self.props.state.user.selectedAddress);
								const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
								zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
									if(resp && resp.agentid) {
										self.props.checkAvailabilityGeneric(skuList, `accountNumber=${self.props.accountNumber}&zipCode=${self.props.getZipCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, '', true, response => {
											self.setState({
												isAvailabilityCallCompleted: true,
												availabilityData: response.responseObject
											}, () => {
												self.callBackAfterAvailabilityAndPricing();
											});
										});
									}
								});

								const { selectedPriceSource } = self.props.state.user;
								const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
								const agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
								self.props.checkPricesForSearchResult({
									account_number: self.props.accountNumber,
									pricing_effective_date: pricingEffectiveDate,
									sa_number: agreementNumber,
									item_numbers: skuListForPricing
								}, false, false, response => {
									response = processPricingResponse(response);
									self.setState({
										isPricingCallCompleted: true,
										pricingData: self.state.pricingData.concat(response.responseObject.items)
									}, () => {
										self.props.saveProductResultPrices(response);
										self.callBackAfterAvailabilityAndPricing();
									});
								});
							});
						}, null);
					});
				}
			});
		});
	}

	callBackAfterAvailabilityAndPricing() {
		const self = this;
		const {
			isGetItemsCallCompleted,
			isAvailabilityCallCompleted,
			isPricingCallCompleted,
			availabilityData,
			getItemsData,
			pricingData
		} = self.state;
		if (isGetItemsCallCompleted && isAvailabilityCallCompleted && isPricingCallCompleted) {
			// const updatedAvailabilityData = [];
			/*availabilityData.forEach(item => {
				const record = getItemsData.find(itm => itm.sku === item.sku);
				if(record) {
					item.description = record.description;
					item.quickSpecPdfName = record.quickSpecPdfName;
					item.finalProductionDate = record.finalProductionDate;
					item.firstDistributionDate = record.firstDistributionDate;
					item.msrp = record.msrp;
					item.brand = record.brand;
					item.category = record.category;
					item.smallAppliance = record.smallAppliance; 
					item.imagePath = record.imagePath;
					item.quickSpecPdfPath = record.quickSpecPdfPath;
				}
			});*/
			for(let i=0; i<availabilityData.length; i++){
				const record = getItemsData.find(itm => itm.sku === availabilityData[i].sku);
				if(record) {
					availabilityData[i].description = record.description;
					availabilityData[i].quickSpecPdfName = record.quickSpecPdfName;
					availabilityData[i].finalProductionDate = record.finalProductionDate;
					availabilityData[i].firstDistributionDate = record.firstDistributionDate;
					availabilityData[i].msrp = record.msrp;
					availabilityData[i].brand = record.brand;
					availabilityData[i].category = record.category;
					availabilityData[i].smallAppliance = record.smallAppliance; 
					availabilityData[i].imagePath = record.imagePath;
					availabilityData[i].quickSpecPdfPath = record.quickSpecPdfPath;
				} else{
					delete availabilityData[i];
				}
			}
			// If no replacement available then show inline message
			const { productResultAvailability } = self.props.state.product;
			productResultAvailability.forEach((item, index) => {
				if(index === self.state.selectedIndex) {
					let isPricingDataAvailable = false;
					availabilityData.forEach(itm => {
						const record = pricingData.find(it => it.item_number === itm.sku);
						if(record && record.records) {
							isPricingDataAvailable = true;
						}
					});
					if(isPricingDataAvailable) {
						item.replacementList = availabilityData;
						item.hideReplacementLink = true;
					} else {
						self.showNoReplacementAvailableMessage(index, item.sku);
					}
				}
			});
			self.props.saveProductResultAvailability({responseObject: productResultAvailability});
			self.props.updateAvailabilityWithPricesAndDiscounts();
		}
	}

	getPimItemsInfo(index, sku, callback) {
		const self = this;
		const skuListForPim = [sku];
		// make service call to get pim details
		self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
			if(response.status) {
				const pimData = response.responseObject ? response.responseObject : null;
				if (pimData) {
					const pimItemData = _.find(pimData, { item_number: sku });
					const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
					const replacementSKUs = hasReplacement ? self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded") : null;
					callback && callback(hasReplacement, replacementSKUs ? replacementSKUs[0] : null, pimItemData);
				} else {
					callback && callback(false, null, null);
				}
			}
		});
	}

	showNoReplacementAvailableMessage(index) {
		const self = this;
		// If no replacement available then show inline message
		const { state } = self.props;
		const { productResultAvailability } = state.product;
		productResultAvailability[index].noReplacementAvail = true;
		self.props.saveProductResultAvailability({responseObject: productResultAvailability});
	}

	doNothing(event) {
		event && event.preventDefault()
	}

	handleRedirect(url, item, availableQty, index, event) {
		event.preventDefault();
		const self = this;
		self.props.fireGTMTag('Product Click', {
			ecommerce: {
				currencyCode: 'USD',
				click: {
					actionField: {
						list: self.props.selectedNarrowYourResult,
					},
					products: [{
						name: item.description,
						id: item.sku,
						price: self.formatNumber2Decimal(item.price.toString()),
						brand: item.brand,
						category: item.category,
						variant: undefined,
						position: index.toString(),
						dimension70: availableQty === '0' ? 'yes' : 'no'
					}]
				}
			}
		});
		browserHistory.push(url);
	}

    render() {
		const self = this;
		let	isPTSAvailable = false,
			isGroupPAAvailable = false,
			isOtherAvailable = false,
			isDraftAvailable = false,
			isVRAvailable = false;
		const { resultLoaded, productResultPrices, isProductAvailabilityCallCompleted, numberOfParallelCallForProductPrices, numberCompletedOfParallelCallForProductPrices } = self.props.state.product;
		const { userDetails: { typeOfUser } } = self.props.state.user;
		let { productNumberKeywordResult } = self.props.state.product;
		let productResultAvailability = self.props.productResultAvailability;
		//let pimLifeCyclePhaseValueSingleItemSearch = productNumberKeywordResult && productNumberKeywordResult.length > 0 ? productNumberKeywordResult[0].lifeCyclePhase : null;
		const isPricingAccess = self.props.isResponsibilityExists("Price");
		if(productResultAvailability) {
			productResultAvailability = JSON.parse(JSON.stringify(productResultAvailability));
			const sorting = this.state.sorting;
			if(sorting === "asc" || sorting === "desc") {
				//sort by high to low
				productResultAvailability = _.orderBy(productResultAvailability, [isPricingAccess ? 'price' : 'msrp'], [sorting]);
				productResultAvailability.sort((a, b) => {
					if(sorting === 'asc') {
						return parseInt(a[isPricingAccess ? 'price' : 'msrp'], 10) - parseInt(b[isPricingAccess ? 'price' : 'msrp'], 10);
					} else {
						return parseInt(b[isPricingAccess ? 'price' : 'msrp'], 10) - parseInt(a[isPricingAccess ? 'price' : 'msrp'], 10);
					}
				});
			} else {
				//Sort by sku number
				productResultAvailability = _.orderBy(productResultAvailability, ['sku'], ['asc']);
			}

			if(self.state.isPriceDiscountAccess && self.state.showDetails) {
				isPTSAvailable = _.filter(productResultAvailability, ['pts', '']).length !== productResultAvailability.length;
				isGroupPAAvailable = _.filter(productResultAvailability, ['groupPA', '']).length !== productResultAvailability.length;
				isOtherAvailable = _.filter(productResultAvailability, ['other', '']).length !== productResultAvailability.length;
				isDraftAvailable = _.filter(productResultAvailability, ['draft', '']).length !== productResultAvailability.length;
				isVRAvailable = _.filter(productResultAvailability, ['pvr', '']).length !== productResultAvailability.length;
			}
		}
		const toolTipContent = `The ETA is when the product will be available to ship from the GE Appliances ADC for an order placed today.<br/><br/>
						<b>6+ mos:</b> Model is currently in production, but demand exceeds all planned supply. "6+ mos." indicates that we cannot provide an exact ETA date. The system estimate for availability under these conditions is greater than 6 months from today.<br/><br/>
						<b>FP:</b> Model is past the final production date and there is no more supply being produced. "FP" indicates that the model cannot be supplied from the serving warehouse and cannot be ordered.`;
        return (
            <div className="productResultsTableForm withNoBeforeUnloadBehavior" name="productResultsTableForm" id="productResultsTableForm">
               	<div className="captionAboveTable productResultsTableHeader">
                  	<div className="inner">
                     	<div className="resultCount">
                        	<span className="resultCount">{isProductAvailabilityCallCompleted && numberOfParallelCallForProductPrices === numberCompletedOfParallelCallForProductPrices && productResultAvailability && productResultAvailability.length} Products</span> match your selections.
                     	</div>
						<div className="sortBy">
							<label>Sort by:&nbsp;
								<select id="sortBy" name="sortBy" className="sortBy font12" onChange={this.handleSorting.bind(this)}>
									<option value="sku">Product Number: A-Z</option>
									<option value="desc">{isPricingAccess ? 'Price' : 'MSRP'}: High to Low</option>
									<option value="asc">{isPricingAccess ? 'Price' : 'MSRP'}: Low to High</option>
								</select>
							</label>
						</div>
                  	</div>
               	</div>
               			<table className={"dataTable productResultsTable " + (this.state.customerType) + (this.state.showPhotos?" photosShown ":" photosHidden ")+(this.state.showDetails?" priceDetailsShown ":" priceDetailsHidden")}>
                  	<thead>
						<tr>
							<th className="compare">
							  	<a className="compareButton blueButton bold uppercase compareProductsLink" href="" onClick={this.handleCompareProducts.bind(this)}>Compare</a>
							</th>
							<th className="photo" style={{display: (this.state.showPhotos?'table-cell':'none')}}>
							  <a className="bold hidePhotosLink" style={{display: (this.state.showPhotos?"inline":"none")}} onClick={this.handleShowHideDetails.bind(this, true)} href="">Hide Photos</a>
							</th>
							<th className="productInfo">
								<a className="bold showPhotosLink" style={{display: (!this.state.showPhotos?"inline":"none")}} onClick={this.handleShowHideDetails.bind(this, false)} href="">Show Photos</a>
							</th>
							<th className="priceColumn msrp">MSRP</th>
							<th className="priceColumn price">
								{self.state.isPricingAccess
									?"Price"
									:null
								}
								<br />
								{self.state.isPricingAccess
									?<span className="unbold">(each)</span>
									:null
								}
							</th>
							{isPTSAvailable
								?<th className="priceColumn priceDetail pts">PTS</th>
								:null
							}
							{isGroupPAAvailable
								?<th className="priceColumn priceDetail groupPA">Group PA</th>
								:null
							}
							{isDraftAvailable
								?<th className="priceColumn priceDetail draft">Draft</th>
								:null
							}
							{isVRAvailable
								?<th className="priceColumn priceDetail pvr">VR</th>
								:null
							}
							{isOtherAvailable
								?<th className="priceColumn priceDetail other">Other</th>
								:null
							}
							{self.state.isPriceDiscountAccess
								?<th className="priceColumn netPrice">Net Price <span className="unbold">(each)</span>
								  	<div>
										<a className="bold hidePriceDetailsLink" style={{display: (this.state.showDetails?"inline":"none")}} href="" onClick={this.handleShowHideDetails.bind(this, false)}>Hide Details</a>
										<a className="bold showPriceDetailsLink" style={{display: (!this.state.showDetails?"inline":"none")}} href="" onClick={this.handleShowHideDetails.bind(this, true)}>Show Details</a>
								  	</div>
								</th>
								:null
							}
							<th className="cart"></th>
						</tr>
                  	</thead>
                  	{/* one [tbody] element for each SKU. */}
                  	{/* in situations where you have one SKU replaced by another SKU, both go in the same [tbody]. */}
                  	{resultLoaded && productResultAvailability && productResultAvailability.length === 0
                      	?<tbody>
                            <tr>
                                <td></td>
                                 <td colSpan={this.state.showDetails?10:6}>No results found.</td>
                            </tr>
                        </tbody>
                      :null
				  	}
					{/*!productResultAvailability
                      	?<tbody>
                            <tr>
								<td></td>
                            	<td className="txt-ctr" colSpan={this.state.showDetails?10:6}><div className="loader">&nbsp;</div></td>
                            </tr>
                        </tbody>
                  		:null
					*/}
                  	{resultLoaded && productResultAvailability && productResultAvailability.length > 0 && productResultAvailability.map((item, index) => {
						let lifeCyclePhaseValueMultipleValues = productNumberKeywordResult && productNumberKeywordResult.filter(itm => itm.sku === item.sku);
						let lifeCyclePhaseValue = lifeCyclePhaseValueMultipleValues && lifeCyclePhaseValueMultipleValues.length > 0 ? lifeCyclePhaseValueMultipleValues[0].lifeCyclePhase : null;
						if(self.props.typeOfSearch === 'product-line' && productResultPrices) {
							let record = _.find(productResultPrices, ['sku', item.sku]);
							let recordNew = _.find(productResultPrices, ['item_number', item.sku]);
							if(record) {
								item.priceDiscounts = record.priceDiscounts;
								item.price = record.price && record.price !== ""?parseFloat(record.price):"";
								item.netPrice = record.netPrice;
							}
							if(recordNew) {
								const rec0 = recordNew.records && recordNew.records[0] ? recordNew.records[0] : {};
								item.modifier_line_end_date = rec0.modifier_line_end_date && moment(rec0.modifier_line_end_date).isValid() ? moment(rec0.modifier_line_end_date).format('MM/DD/YYYY') : '';
							}
						}
						if(self.props.typeOfSearch === 'product-number' && productResultPrices) {
							let record = _.find(productResultPrices, ['item_number', item.sku]);
							if(record){
								item.priceDiscounts = record.priceDiscounts;
								const rec0 = record.records && record.records[0] ? record.records[0] : {};
								item.modifier_line_end_date = rec0.modifier_line_end_date && moment(rec0.modifier_line_end_date).isValid() ? moment(rec0.modifier_line_end_date).format('MM/DD/YYYY') : '';
								item.modifier_line_start_date = rec0.modifier_line_start_date && moment(rec0.modifier_line_start_date).isValid() ? moment(rec0.modifier_line_start_date).format('MM/DD/YYYY') : '';
								item.modifier_name = rec0.modifier_name || '';
							}
						}
						let data = {
							availableQty: item.availableQty,
							intransitQty: item.intransitQty,
							etaDate: item.etaDate,
						};
						if(self.props.checkIfFP(item)) {
							data.intransitQty = null;
							data.etaDate = 'FP';
						} else {
							data = self.props.validateFDD(item);
						}
                      	return <tbody key={index}>
                          	<tr className={item.forItemToBeCompared?"forItemToBeCompared":""}>
								<td className="compare">
									<div>
										<input onClick={this.handleCompareCheck.bind(this, item.sku)} className="compareSkuCheckbox" defaultChecked={item.forItemToBeCompared} id={"compareSku_"+item.sku} type="checkbox" name={"compareSku"+item.sku} value={item.sku} />
									</div>
									{item.forItemToBeCompared
										?<p className="whenSkuSelected" style={{display: 'block'}}><a href="" onClick={this.handleCompareProducts.bind(this)} className="compareProductsLink">Compare Products Now</a></p>
										:<p className="whenSkuNotSelected" style={{display: 'block'}}><label htmlFor={"compareSku_"+item.sku}>select to <span className="uppercase">Compare Products</span></label></p>
									}
								</td>
                             	<td className="photo" style={{display: (this.state.showPhotos?'table-cell':'none')}}>
	                             	<a href="" onClick={this.handleRedirect.bind(this, "/product-specs/"+self.props.typeOfSearch+"/"+item.sku, item, data.availableQty, (index + 1))}>
									 <img src={item.imagePath} width={96} height={100} alt={item.sku} title={item.sku}/>
                                 	</a>
                             	</td>
                             	<td className="productInfo">
	                                <div className="skuDiv">
                                   		<a href="" onClick={this.handleRedirect.bind(this, "/product-specs/"+self.props.typeOfSearch+"/"+item.sku, item, data.availableQty, (index + 1))}>{item.sku}</a>
	                                </div>
	                                <div className="productNameDiv">
	                                   	{item.description}
	                                </div>
									<div>
										<div className="quickspecs-email-container">
											{item.quickSpecPdfName && item.quickSpecPdfName !== ""
			                                    ?<div className="quickSpecLinkDiv">
												    <a href={item.quickSpecPdfPath} className="withIcon withQuickSpecIcon bold uppercase" target="_blank">Quick Spec</a>
			                                    </div>
			                                    :null
			                                }
			                                <div className="emailSpecLinkDiv">
			                                	<a className="withIcon withEmailSpecIcon bold uppercase" onClick={this.handleClickEmailSpec.bind(this, "/prelogin/product-specs/"+ self.props.typeOfSearch+"/"+item.sku)} href="">Email Spec</a>
			                                </div>
										</div>
										{((item.availableQty === "0" && item.finalProductionDate && item.finalProductionDate.indexOf('1900') === -1) || lifeCyclePhaseValue === "Near End of Life" )&& <div className="viewReplacementLinkDiv">
											{item.noReplacementAvail
												?<span className="red bold">No Replacements available.</span>
												: (!item.hideReplacementLink || lifeCyclePhaseValue === "Near End of Life") && <a className="bold uppercase" onClick={this.handleReplacement.bind(this, index, item.sku, null)} href="">View Replacement</a>
											}
		                                </div>}
									</div>
                             	</td>
                             	<td className="priceColumn msrp" style={{width:"18%"}}>
                                	{this.formatNumber2Decimal(item.msrp)}
                                	<div className="productStatusTablePositioningContainer">
                                   		<table className="productStatusTable">
                                      		<thead>
	                                         	<tr>
		                                            <th>Avail.</th>
		                                            <th>Next Avail</th>
		                                           <th>ETA <a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "ToolTipOverlayDialog", true)}>
														<img src="../../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
	                                         	</tr>
                                      		</thead>
                                      		<tbody>
	                                         	{/* NOTE: usually the <tbody> section contains one row. We're just depicting two scenarios here: one where there's an ETA, and the other where it's a closeout. */}
	                                         	{lifeCyclePhaseValue !== "Near End of Life" ?<tr>
	                                            	<td>{typeOfUser === 'employee' ? <a href="" onClick={this.handleAvailabilityClick.bind(this, item.sku, item.closeout)}>{data.availableQty}</a>:data.availableQty}</td>
													<td>{data.intransitQty == "10000000000"? "1":data.intransitQty}</td>
	                                            	<td>
														{self.props.formatETADate(data.etaDate)}
													</td>
	                                         	</tr>: <tr>
															<td></td>
															<td>
																NLA
															</td>
															<td></td>
													 </tr>}
	                                      	</tbody>
	                                   	</table>
                                	</div>
                             	</td>
								 <td className="priceColumn price" style={{width:"8%"}}>
									{self.state.isPricingAccess && item.price
										?this.formatNumber2Decimal(item.price.toString())
										:null
									}
									{/*In case of contact adjUnitPrice will be the price, it is saved in netPrice object hence using netPrice here
									{self.state.isPricingAccess && this.state.customerType === 'contract' && item.netPrice
										?this.formatNumber2Decimal(item.netPrice.toString())
										:null
									}*/}
								</td>
								{isPTSAvailable
									?<td className="priceColumn priceDetail pts">{this.formatNumber2Decimal(item.pts)}</td>
									:null
								}
								{isGroupPAAvailable
									?<td className="priceColumn priceDetail groupPA">{this.formatNumber2Decimal(item.groupPA)}</td>
									:null
								}
								{isDraftAvailable
									?<td className="priceColumn priceDetail draft">{this.formatNumber2Decimal(item.draft)}</td>
									:null
								}
								{isVRAvailable
									?<td className="priceColumn priceDetail pvr">{this.formatNumber2Decimal(item.pvr)}</td>
									:null
								}
								{isOtherAvailable
									?<td className="priceColumn priceDetail Other">{this.formatNumber2Decimal(item.other)}</td>
									:null
								}
								{self.state.isPriceDiscountAccess
									?<td className="priceColumn netPrice" style={{width:"8%"}}>
										{item.netPrice && <div style={{display: 'block'}}>{this.formatNumber2Decimal(item.netPrice)}</div>}
										{(() => {
											const endDisplay = item.modifier_line_end_date && item.modifier_line_end_date !== '' ? item.modifier_line_end_date : (item.promoDisplay ? item.promoDisplay.split(' - ')[1]:null || null);
											const tooltip = item.modifier_line_end_date && item.modifier_line_end_date !== '' ? `Promotional price ending ${item.modifier_line_end_date}` : (item.promoExpiration ? `Promotional price ${item.promoExpiration}` : undefined);
											if (!endDisplay) return null;
											return (
												<span title={tooltip} style={{ cursor: tooltip ? 'help' : 'default' }}>
													Ends {endDisplay}
												</span>
											);
										})()}
										<br/>
										{self.state.isPriceDiscountAccess && this.state.customerType === "retail" && !item.closeout && (
    										<a href="" onClick={this.handlePriceBreakdownOpen.bind(this, item)}>Price Details</a>)}
										{item.netNet
											?<div style={{whiteSpace: 'nowrap'}} className="closeout">Net-Net</div>
											:null
										}
										{item.closeout
											?<div className="closeout">Closeout</div>
											:null
										}
									</td>
									:null
								}
								<td className="cart">
									{self.props.checkIfFP(item) || lifeCyclePhaseValue === "Near End of Life"
										? <a className="grayButton blockButton" style={{width: '100%'}} onClick={self.doNothing} href="" disabled>NLA</a>
                                		: <AddToCart price={item.price} brand={item.brand} category={item.category} list={self.props.selectedNarrowYourResult} whichPage="product list" position={index + 1} fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} getPimDataForCartItem={this.props.getPimDataForCartItem} style={{width: "44%"}} item={item.sku} itemDescription={item.description} itemType={item.itemType} makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
									}
                  	<AddToList fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} item={item.sku} itemDescription={item.description}  itemType={item.itemType} getZipCode={self.props.getZipCode} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
								</td>
                          	</tr>
							{item.replacementList && item.replacementList.map((itm, ind) => {
								let data = {
									availableQty: itm.availableQty,
									intransitQty: itm.intransitQty,
									etaDate: itm.etaDate,
								};
								if(self.props.checkIfFP(itm)) {
									data.intransitQty = null;
									data.etaDate = 'FP';
								} else {
									data = self.props.validateFDD(itm);
								}
								return [
									<tr className="replacedBy">
										<td></td>
										<td className="dynamicColumnSpan" colSpan={this.state.showDetails?3:4}>
											<span className="replacedByText">Replaced By:</span>
										</td>
										{isPTSAvailable
											?<td className="priceColumn priceDetail pts"></td>
											:null
										}
										{isGroupPAAvailable
											?<td className="priceColumn priceDetail groupPA"></td>
											:null
										}
										{isDraftAvailable
											?<td className="priceColumn priceDetail draft"></td>
											:null
										}
										{isVRAvailable
											?<td className="priceColumn priceDetail pvr"></td>
											:null
										}
										{isOtherAvailable
											?<td className="priceColumn priceDetail Other"></td>
											:null
										}
										{self.state.isPriceDiscountAccess
											?<td className="priceColumn netPrice"></td>
											:null
										}
										<td className="cart">
										</td>
									</tr>,
									<tr className={itm.forItemToBeCompared?"forItemToBeCompared":""}>
										<td className="compare">
											<div>
												<input onClick={this.handleCompareCheck.bind(this, itm.sku)} className="compareSkuCheckbox" defaultChecked={itm.forItemToBeCompared} id={"compareSku_"+itm.sku} type="checkbox" name={"compareSku"+itm.sku} value={itm.sku} />
											</div>
											{itm.forItemToBeCompared
												?<p className="whenSkuSelected" style={{display: 'block'}}><a href="" onClick={this.handleCompareProducts.bind(this)} className="compareProductsLink">Compare Products Now</a></p>
												:<p className="whenSkuNotSelected" style={{display: 'block'}}><label htmlFor={"compareSku_"+itm.sku}>select to <span className="uppercase">Compare Products</span></label></p>
											}
										</td>
		                             	<td className="photo" style={{display: (this.state.showPhotos?'table-cell':'none')}}>
										 	<Link to="" onClick={this.handleClickOnImage.bind(this,itm.imagePath)}>
		                                     	<img src={itm.imagePath} width={96} height={100} alt={itm.sku} title={itm.sku} />
		                                 	</Link>
		                             	</td>
		                             	<td className="productInfo">
			                                <div className="skuDiv">
		                                   		<a href="" onClick={this.handleRedirect.bind(this, "/product-specs/"+self.props.typeOfSearch+"/"+itm.sku, itm, data.availableQty, (index + 1) + (ind + 1))}>{itm.sku}</a>
			                                </div>
			                                <div className="productNameDiv">
			                                   	{itm.description}
			                                </div>
			                                {itm.quickSpecPdfName && itm.quickSpecPdfName !== ""
			                                    ?<div className="quickSpecLinkDiv">
			                                      <a href={itm.quickSpecPdfPath} className="withIcon withQuickSpecIcon bold uppercase" target="_blank">Quick Spec</a>
			                                    </div>
			                                    :null
			                                }
			                                <div className="emailSpecLinkDiv">
			                                	<a className="withIcon withEmailSpecIcon bold uppercase" onClick={this.handleClickEmailSpec.bind(this, "/prelogin/product-specs/"+ self.props.typeOfSearch+"/"+itm.sku)} href="">Email Spec</a>
			                                </div>
		                             	</td>
		                             	<td className="priceColumn msrp">
		                                	{this.formatNumber2Decimal(itm.msrp)}
		                                	<div className="productStatusTablePositioningContainer">
		                                   		<table className="productStatusTable">
		                                      		<thead>
			                                         	<tr>
				                                            <th>Avail.</th>
				                                            <th>Next Avail</th>
				                                            <th>ETA</th>
			                                         	</tr>
		                                      		</thead>
		                                      		<tbody>
			                                         	{/* NOTE: usually the <tbody> section contains one row. We're just depicting two scenarios here: one where there's an ETA, and the other where it's a closeout. */}
			                                         	 <tr>
			                                            	<td>
																{typeOfUser === 'employee'
																	? <a href="" onClick={this.handleAvailabilityClick.bind(this, itm.sku, itm.closeout)}>{data.availableQty}</a>
																	: data.availableQty
																}
															</td>
			                                            	<td>
																<td>{data.intransitQty == "10000000000"? "1":data.intransitQty}</td>
															</td>
			                                            	<td>
																{self.props.formatETADate(data.etaDate)}
															</td>
			                                         	</tr>
			                                      	</tbody>
			                                   	</table>
		                                	</div>
		                             	</td>
										<td className="priceColumn price">
											{self.state.isPricingAccess && itm.price
												?this.formatNumber2Decimal(itm.price.toString())
												:null
											}
											{/*In case of contact adjUnitPrice will be the price, it is saved in netPrice object hence using netPrice here
											{self.state.isPricingAccess && this.state.customerType === 'contract' && itm.netPrice
												?this.formatNumber2Decimal(itm.netPrice.toString())
												:null
											}*/}
										</td>
										{isPTSAvailable
											?<td className="priceColumn priceDetail pts">{this.formatNumber2Decimal(itm.pts)}</td>
											:null
										}
										{isGroupPAAvailable
											?<td className="priceColumn priceDetail groupPA">{this.formatNumber2Decimal(itm.groupPA)}</td>
											:null
										}
										{isDraftAvailable
											?<td className="priceColumn priceDetail draft">{this.formatNumber2Decimal(itm.draft)}</td>
											:null
										}
										{isVRAvailable
											?<td className="priceColumn priceDetail pvr">{this.formatNumber2Decimal(itm.pvr)}</td>
											:null
										}
										{isOtherAvailable
											?<td className="priceColumn priceDetail Other">{this.formatNumber2Decimal(itm.other)}</td>
											:null
										}
										{self.state.isPriceDiscountAccess
											?<td className="priceColumn netPrice">
												{itm.netPrice && <div style={{display: 'block'}}>{this.formatNumber2Decimal(itm.netPrice)}</div>}
												{itm.netNet
													?<div style={{whiteSpace: 'nowrap'}} className="closeout">Net-Net</div>
													:null
												}
												{itm.closeout
													?<div className="closeout">Closeout</div>
													:null
												}
											</td>
											:null
										}
										<td className="cart">
											{self.props.checkIfFP(itm)  && item.lifeCyclePhase === "Near End of Life"
												? <a className="grayButton blockButton" style={{width: '100%'}} onClick={self.doNothing} href="" disabled>NLA</a>
			                                    :<AddToCart price={itm.price} brand={itm.brand} category={itm.category} list={self.props.selectedNarrowYourResult} whichPage="product list" position={index + ind + 2} fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} getPimDataForCartItem={this.props.getPimDataForCartItem} item={itm.sku} itemDescription={itm.description}  itemType={item.itemType} makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
											}
		                                   	<AddToList fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} item={itm.sku} itemDescription={itm.description}  itemType={item.itemType} getZipCode={self.props.getZipCode} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
										</td>
		                          	</tr>
								]
							})}
						</tbody>
                  	})}
               	</table>
               	{this.state.showEmailSpecOverlayDialog?<EmailSpecOverlayDialog specURL={this.state.specURL} dispatch={this.props.dispatch} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>:null}
               	{(this.props.state && this.props.state.brochure.emailSendSuccessDialog === true)?<EmailSpecOverlayDialogSuccess dispatch={this.props.dispatch} showDialog={true}/>:null}
				{(this.state.showAvailabilityByADCDialog && this.state.availabilityADCData)?<AvailabilityByADCOverlayDialog data={this.state.availabilityADCData} handleADCDialogStatus={this.handleADCDialogStatus.bind(this)} showDialog={true} />:null}
				{this.state.showToolTipOverlayDialog?<ToolTipOverlayDialog title="ETA" content={toolTipContent} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.renderPriceBreakdownModal()}
            </div>
        );
    }
}

const overlayStyles = {
	backdrop: {
		position: 'fixed',
		top: 0, left: 0, right: 0, bottom: 0,
		backgroundColor: 'rgba(0,0,0,0.45)',
		zIndex: 1000,
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'center',
		paddingTop: '80px',
	},
	dialog: {
		background: '#fff',
		border: '3px solid #3b73b9',
		borderRadius: '3px',
		minWidth: '300px',
		maxWidth: '400px',
		boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
		padding: '0px 10px 0px 10px ',
		overflow: 'hidden',    
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		color: '#092c74 ',
		padding: '10px 14px',
		borderBottom: '1px solid #aaa',
	},
	title: {
		fontWeight: '800',
		fontSize: '13px',
		letterSpacing: '0.5px',
	},
	closeBtn: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		color: '#092c74',
		fontSize: '18px',
		lineHeight: 1,
		padding: 0,
		display: 'flex',
		alignItems: 'center',
	},
	table: {
		width: '100%',
		borderCollapse: 'collapse',
		padding: '8px 0',
	},
	labelCell: {
		padding: '6px 14px',
		fontSize: '12px',
		color: '#333',
	},
	valueCell: {
		padding: '6px 14px',
		fontSize: '12px',
		color: '#333',
		textAlign: 'right',
		whiteSpace: 'nowrap',
	},
	discountValue: {
		color: '#c00',
	},
	expiry: {
		fontSize: '11px',
		color: '#888',
	},
	totalRow: {
		borderTop: '1px solid #aaa',
	},
	netPriceRow: {
	// 	borderTop: '2px solid #333',
	// 	backgroundColor: '#f5f5f5',
	},
	netPriceLabel: {
		fontWeight: 'bold',
		fontSize: '13px',
	},
	netPriceValue: {
		fontWeight: 'bold',
		fontSize: '13px',
		color: '#333',
	},
};

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	resetProductAvailabilityResultList: () => dispatch(resetProductAvailabilityResultList()),
	saveProductResultAvailability: (data) => dispatch(saveProductResultAvailability(data)),
	updateAvailabilityWithPricesAndDiscounts: () => dispatch(updateAvailabilityWithPricesAndDiscounts()),
	getADC: (data, callback) => dispatch(getADC(data, callback)),
	saveADC: (data) => dispatch(saveADC(data)),
	saveProductResultPrices: (data) => dispatch(saveProductResultPrices(data)),
	getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
	checkPricesForSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForSearchResult(data, showLoader, saveToStore, callback)),
	// closeoutModelAvailability: (hybridQueryParams, callback) => dispatch(closeoutModelAvailability(hybridQueryParams, callback)),
	getSearchKeywordSuggestionList: (payload, callback) => dispatch(getSearchKeywordSuggestionList(payload, callback)),
});

PostLoginSearchResult = connect(mapStateToProps, mapDispatchToProps)(PostLoginSearchResult);
export default PostLoginSearchResult;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SearchResult/productSearchResult.js